export const cognitoConfig = {
  region: import.meta.env.VITE_ABP_AWS_REGION || 'us-east-1',
  userPoolId: import.meta.env.VITE_ABP_COGNITO_USER_POOL_ID || 'us-east-1_ekLT9M2GN',
  clientId: import.meta.env.VITE_ABP_COGNITO_CLIENT_ID || '4nnog289erv9j463rem6k2airm',
  domain: import.meta.env.VITE_ABP_COGNITO_DOMAIN || 'gdna-abp-simple-1769397021.auth.us-east-1.amazoncognito.com',
};
